import { render, staticRenderFns } from "./StatsDsp.vue?vue&type=template&id=5365e308&"
import script from "./StatsDsp.vue?vue&type=script&lang=js&"
export * from "./StatsDsp.vue?vue&type=script&lang=js&"
import style0 from "./StatsDsp.vue?vue&type=style&index=0&id=5365e308&prod&lang=scss&"
import style1 from "./StatsDsp.vue?vue&type=style&index=1&id=5365e308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports